var _a;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import template from './actionsOptionList.view.html';
import { translate } from 'angular';
import { AddAction } from '../addAction/addAction.dispatcher';
import { ActionViewModel } from '../../../../models/viewModels/ActionViewModel';
let ActionsOptionListComponent = class ActionsOptionListComponent {
    static $inject = ['$translate'];
    constructor($translate) {
        'ngInject';
        this.$translate = $translate;
    }
    $dispatch($action) {
        if (this.onAction) {
            this.onAction({ $action });
        }
        else {
            throw new Error('onAction is not implemented');
        }
    }
    onAddAction(type) {
        const action = new AddAction({
            action: new ActionViewModel({
                type,
                $title: this.getActionTypeTitle(type),
            }),
        });
        this.$dispatch(action);
    }
    getActionTypeTitle(type) {
        const toCamelCase = (value) => value.charAt(0).toLowerCase() + value.slice(1);
        const translateResource = `builder-tabs-actions.${toCamelCase(type.toString())}.title`;
        return this.$translate.instant(translateResource);
    }
};
//#endregion
// #region properties
ActionsOptionListComponent.$inject = ['$translate'];
ActionsOptionListComponent = __decorate([
    Component({
        template,
        bindings: {
            state: '=',
            type: '&',
            onClose: '&',
            onAction: '&?',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof translate !== "undefined" && translate.ITranslateService) === "function" ? _a : Object])
], ActionsOptionListComponent);
export { ActionsOptionListComponent };
